import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import classes from './Test.module.css';

const NewsSection = () => {
  return (
    <section className={`${classes.main} ${classes.pb20} ${classes.p40}`}>
 <div className="row justify-content-center text-center">
      <div className="col-12">
        <h1 className="bannerHeding mb-4" style={{color:"#00238a"}}>
          CURRENT NEWS
          {/* className="fst-italic"
          <span className="bannerIttalic"> Experienced Hands</span> */}
        </h1>
      </div>
    </div>
      <Container>
        <Row className="justify-content-center">
          <Col md={4} className="pb-3">
            <article className={classes.card}>
              <div className={classes.cardImageBox}>
                <img src="/news.jfif" alt="awards" className={classes.cardImage} width="480" height="719" />
              </div>
              <article className={classes.cardSecB}>
                <div className={classes.cardSecBHeader}>
                  <h3 className={classes.cardSecBtitle}>Latest Updates</h3>
                </div>
                <div className={classes.cardSecBAction}>
                  <button className={classes.cardSecBButton}>See Updates</button>
                </div>
              </article>
            </article>
          </Col>
          <Col md={4} className="pb-3">
            <article className={classes.card}>
              <div className={classes.cardImageBox}>
                <img src="/news.jfif" alt="awards" className={classes.cardImage} width="480" height="719" />
              </div>
              <article className={classes.cardSecB}>
                <div className={classes.cardSecBHeader}>
                  <h3 className={classes.cardSecBtitle}>NewsLetter</h3>
                </div>
                <div className={classes.cardSecBAction}>
                  <button className={classes.cardSecBButton}>Subscribe</button>
                </div>
              </article>
            </article>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NewsSection;